export default "__VITE_PUBLIC_ASSET__2b9af3f9__"